import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";

const ADVENTURES = [
  { emoji: "🎮", title: "Match the Meaning", desc: "Connect words to child-friendly meanings — easy, medium, or hard.", color: "bg-[#eaf2ff]", href: "/kids-corner", id: "word-game" },
  { emoji: "🧚", title: "Sentence Builder with Lumi", desc: "Tap words, build a sentence, and hear Lumi read it back with a gentle tip.", color: "bg-[#fdeef4]", href: "/kids-corner", id: "sentence-builder" },
  { emoji: "🎧", title: "Hear & Choose", desc: "Listen carefully and pick the best picture — in the installable Word Play app.", color: "bg-[#fff5e9]", href: "/kids-vocab", id: "hear-choose" },
  { emoji: "✍️", title: "Trace & Say", desc: "Finger-trace a word, then use it in a sentence out loud.", color: "bg-[#e9f5f3]", href: "/kids-vocab", id: "trace-say" },
  { emoji: "📖", title: "Story Magic", desc: "Write a few sentences and watch them turn into a picture.", color: "bg-[#f2effb]", href: "/kids-corner", id: "story-magic" },
  { emoji: "🏆", title: "Earn Private Badges", desc: "Celebrate progress without public rankings — progress stays private.", color: "bg-[#fff1e6]", href: "/kids-corner", id: "badges" },
];

export const AdventureSection = () => (
  <section id="adventures" className="py-14 sm:py-20 px-4 scroll-mt-28" aria-labelledby="adventures-title">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl mb-10">
        <span className="font-nunito font-bold text-xs uppercase tracking-[0.2em] text-[#ff8518] inline-block">Pick an activity!</span>
        <h2 id="adventures-title" className="font-nunito font-extrabold tracking-tight text-3xl sm:text-4xl text-[#17284b] mt-1">
          Choose a word adventure
        </h2>
        <p className="font-nunito text-base sm:text-lg text-[#596882] mt-3">
          Simple activities, clear directions, and lots of encouragement — designed with SPED and ESL/ELL learners in mind.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="adventure-grid">
        {ADVENTURES.map((a, i) => (
          <motion.a
            key={a.id}
            href={a.href}
            data-testid={`adventure-${a.id}`}
            className={`${a.color} group border border-[#d4dff0] rounded-3xl p-6 flex flex-col gap-3 hover:-translate-y-1 transition-transform`}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06 }}
          >
            <span className="text-5xl leading-none" aria-hidden="true">{a.emoji}</span>
            <h3 className="font-nunito font-extrabold tracking-tight text-xl text-[#17284b]">{a.title}</h3>
            <p className="font-nunito text-sm sm:text-base text-[#3f4d66] leading-relaxed flex-1">{a.desc}</p>
            <span className="inline-flex items-center gap-1 font-nunito font-bold text-sm text-[#17284b]">
              Play now <ArrowRight size={16} weight="bold" className="group-hover:translate-x-1 transition-transform" />
            </span>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
